import { render, staticRenderFns } from "./UserTypeDataTable.vue?vue&type=template&id=658c62f0"
import script from "./UserTypeDataTable.vue?vue&type=script&lang=js"
export * from "./UserTypeDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports